<template>
  <div :class="`modal-container${isActive ? ' is-active' : ''}${isLarge ? ' is-large' : ''}`">
    <div class="modal__overlay"></div>
    <div class="modal">
      <a class="modal__close" tabindex="0" @click.prevent="close">
        <icon name="times" />
      </a>
      <h2 class="modal__header">{{ header }}</h2>
      <div class="modal__content">
        <slot/>
      </div>
      <div class="modal__buttons" v-if="$scopedSlots.modalButtons">
        <slot name="modalButtons" :close="close"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: [
    'name',
    'header',
    'isInitiallyActive',
    'isLarge'
  ],
  data () {
    return {
      isActive: false
    }
  },
  created () {
    this.isActive = this.isInitiallyActive
    this.$bus.$on('openModal', (name) => {
      if (this.name === name) {
        this.isActive = true
      }
    })
  },
  methods: {
    close () {
      this.isActive = false
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .modal
    position: fixed
    top: 50%
    left: 50%
    transform: translate3d(-50%, -50%, 0) scale(0.8)
    background-color: #fff
    max-width: 95%
    width: 650px
    z-index: 999
    border-radius: 3px
    &__overlay
      position: fixed
      background-color: rgba(0, 0, 0, 0.8);
      height: 100%
      width: 100%
      top: 0
      left: 0
      z-index: 999
    &__header
      padding: $spacing-base
      border-bottom: 1px solid $color-border
      margin-bottom: 0
      color: $color-main
      text-transform: uppercase
    &__content
      padding: $spacing-base
    &__buttons
      padding: $spacing-base
      border-top: 1px solid $color-border
      @include clearfix
    &__close
      z-index: 3
      line-height: 0
      background: #fff
      border-radius: 30px
      position: absolute
      right: -10px
      top: -10px
      padding: 5px
      border: 3px solid $color-error
      &:hover
        background: $color-error
        cursor: pointer
        svg
          color: #fff
      svg
        height: 12px
        width: 12px
        color: $color-error
        margin: 0
  .modal-container
    opacity: 0
    visibility: hidden
    pointer-events: none
    &.is-large
      .modal
        width: 850px
    &.is-active
      opacity: 1
      visibility: visible
      pointer-events: initial
      .modal
        transform: translate3d(-50%, -50%, 0) scale(1)
        transition: all .25s ease
</style>
